import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InEvidenzaComponent } from './in-evidenza.component';
import { InEvidenzaPostComponent } from './in-evidenza-post/in-evidenza-post.component';

const routes: Routes = [
  { path: ':inEvidenzaId', component: InEvidenzaPostComponent },
  { path: '', component: InEvidenzaComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InEvidenzaRoutingModule { }
